@if (!histories?.length) {
  <h3 class="no-results pt-1 pb-1">
    {{ histories?.length === 0 ? 'No results found.' : 'Loading...' }}
  </h3>
} @else {
  @for (history of histories; track history) {
    <div class="item" [class.show-scenario-name]="showScenarioName">
      @if (isHistoryNote(history); as note) {
        @if (note.title) {
          <mat-icon class="pr-1">history</mat-icon>
        }
        @if (!note.title) {
          <mat-icon class="pr-1">comment</mat-icon>
        }
        <div class="info-row">
          <div>
            <div class="title">
              {{ note.title || note.description }}
            </div>
            @if (note.title) {
              <div>
                {{ note.description }}
              </div>
            }
            @if (note.noteActionType === 'CompleteRequirement') {
              <div class="note-complete">[Requirement marked complete]</div>
            }
            @if (!showScenarioName) {
              <div class="note-info">by: {{ history.actor }}</div>
            }
            @if (showScenarioName && history.scenarioName) {
              <div class="font-italic scenario-name">
                <span>{{ history.scenarioName }}</span>
                @if (history.requirementName) {
                  <span class="align-to-text">&gt;</span>
                }
                @if (history.requirementName) {
                  <span>{{ history.requirementName }}</span>
                }
              </div>
            }
          </div>
          <div class="text-right">
            <div>
              {{ history.happenedOn | date: 'medium' }}
            </div>
            @if (showScenarioName) {
              <div>{{ history.actor }}</div>
            }
          </div>
        </div>
      }
      @if (isHistoryUpdate(history); as update) {
        <mat-icon class="pr-1">history</mat-icon>
        <div class="info-row">
          <div>
            <span class="title">
              {{ updateTitle(update) }}
            </span>
            @for (property of update.properties; track property) {
              <div
                class="limit-width"
                [innerHTML]="propertyDescription(update.stateName, property)"
              ></div>
            }
            @if (!showScenarioName) {
              <div class="note-info">by: {{ history.actor }}</div>
            }
          </div>
          <div class="text-right">
            <div>
              {{ history.happenedOn | date: 'medium' }}
            </div>
            @if (showScenarioName) {
              <div>{{ history.actor }}</div>
            }
          </div>
        </div>
      }
    </div>
  }
}
